'use strict';

const lazyLoadEls = '.js-lazy-load';
const lazyLoadProps = {
    effect: 'fadeIn',
    effectTime: 150
};

/**
 * @description Initializes lazy loading events
 */
function initLazyLoad() {
    const $lazyLoadElements = $(lazyLoadEls);

    if ($lazyLoadElements.length > 0) {
        $lazyLoadElements.lazy(lazyLoadProps);
    }
}

/**
 * @description Prepares all Lazy Load elements. If a data-retina attr exists
 * but not a data-src, create a data-src with the retina url as a fallback.
 */
function prepareLazyLoad() {
    $(lazyLoadEls).each(function() {
        const retinaUrl = $(this).data('retina');
        const srcUrlIsSet = $(this).data('src');

        if (retinaUrl && !srcUrlIsSet) {
            $(this).attr('data-src', retinaUrl);
        }
    });
}

/**
 * @description Triggers previously binded event and lazy loads the elements
 * in the navigation.
 */
function lazyLoadInNavigation(navItem, skipStatus) {
    const $navItem = $(navItem);
    const $lazyLoadEls = $navItem.find(lazyLoadEls);

    if (!skipStatus && $navItem.data('lazyload-status') !== 'loaded') {
        $navItem.data('lazyload-status', 'loaded');
        $lazyLoadEls.lazy(lazyLoadProps);
    }

    if (skipStatus) {
        $lazyLoadEls.lazy(lazyLoadProps);
    }
}

const lazyLoadHelper = {
    init: function() {
        prepareLazyLoad();
        initLazyLoad();
    },

    lazyLoadInNavigation: lazyLoadInNavigation
};

module.exports = lazyLoadHelper;
